import React from 'react'

import style from './AuthLayout.module.css'

export default function AuthLayout({ children }) {
  return <div className={style.root}>{children}</div>
}
